import React, { useState } from "react";
import { TabPanel, TabView } from "primereact/tabview";
import Panel from "../../../../components/panel/panel";
import { Link, useLocation, useParams } from "react-router-dom";
import { BreadCrumb } from "primereact/breadcrumb";
import WhatsappSendDays from "./WhatsappSendDays";
import WhatsappConnect from "./WhatsappConnect";

const WhatsAppQRCode = () => {
  const { id } = useParams(); //get id
  let { state } = useLocation();
  const items = [
    {
      template: () => (
        <Link to={`/salesManagement`} className="p-breadcrumb-link">
          {state ? state.name : "Empreendimento"}
        </Link>
      ),
    },
  ];

  const home = {
    template: () => (
      <Link to={"/salesManagement"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };
  const [isDisable, setIsDisable] = useState(true);
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <>
      <div>
        <BreadCrumb
          model={items}
          home={home}
          style={{
            background: "transparent",
            border: "none",
            fontSize: "16px",
          }}
        />
      </div>

      <Panel title="Configurar Módulo WhatsApp">
        <TabView
          activeIndex={activeIndex}
          onTabChange={(e) => setActiveIndex(e.index)}
          className="meu-tabview pt-3"
        >
          <TabPanel
            header="Conectar WhatsApp"
            leftIcon="fa-solid fa-qrcode mx-2"
          >
            <WhatsappConnect
              enterpriseName={state ? state.name : "Empreendimento"}
              id={id}
              setIsDisable={setIsDisable}
            />
          </TabPanel>

          <TabPanel
            header="Configurar Dias de Envio"
            // disabled={isDisable}
            leftIcon="fa-solid fa-paper-plane mx-2"
          >
            <WhatsappSendDays id={id} />
          </TabPanel>
        </TabView>
      </Panel>
    </>
  );
};

export default WhatsAppQRCode;
